import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_vehicle_ownerships`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}
 
function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_vehicle_ownerships/${id}`, options)
    .then(response => {
      let vehicle_ownership = jsona.deserialize(response.data);
      delete vehicle_ownership.links;
      return vehicle_ownership;
    });
}

function add(vehicle_ownerships) {
  
  console.log(vehicle_ownerships);
  const payload = jsona.serialize({
    stuff: vehicle_ownerships,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_vehicle_ownerships`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(vehicle_ownership) {
  const payload = jsona.serialize({
    stuff: vehicle_ownership,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
 
  return axios.patch(`${url}/fms/fms_vehicle_ownerships/${vehicle_ownership.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}
function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/fms/fms_vehicle_ownerships/${id}`, options);
}




export default {
  list,
  get,
  add,
  update,
  destroy
};

